export default function() {
    const countryId = document.querySelector('.smoking-prevelance-info').getAttribute('data-country-id');

    const currencyMap = {
        'USD': 'usd',
        'Local Currency': 'local_currency_unit',
        'PPP': 'ppp'
    };

    document.querySelectorAll('.prevalence-percentage__grid-item').forEach(item => {
        item.addEventListener('click', function() {
            document.querySelectorAll('.prevalence-percentage__grid-item').forEach(i => i.classList.remove('selected'));
            this.classList.add('selected');
            updateDisplay();
            updateDownloadLink()
        });
    });

    document.querySelectorAll('input[name="currency_selection"]').forEach(radio => {
        radio.addEventListener('change', function() {
            document.querySelectorAll('.currency__option').forEach(label => label.classList.remove('selected'));
            this.nextElementSibling.classList.add('selected');
            updateDisplay();
            updateDownloadLink()
        });
    });

    function updateDownloadLink() {
        const selectedCurrencyLabel = document.querySelector('input[name="currency_selection"]:checked').value;
        const selectedCurrency = currencyMap[selectedCurrencyLabel];
        const selectedPrevalence = document.querySelector('.prevalence-percentage__grid-item.selected').getAttribute('data-index');
        const downloadLink = document.querySelector('#download-pdf-button');
        downloadLink.href = `/costing-tool-pdf?country=${countryId}&currency=${selectedCurrency}&prevalence=${selectedPrevalence}`;
    }

    function updateDisplay() {
        const selectedCurrency = document.querySelector('input[name="currency_selection"]:checked').value;
        const selectedPercentage = document.querySelector('.prevalence-percentage__grid-item.selected').getAttribute('data-index');

        document.querySelectorAll('.col-2-section').forEach(section => {
            section.style.display = 'none';
        });

        document.querySelectorAll('.smoking-prevelance-info__content').forEach(section => {
            section.style.display = 'none';
        });

        const targetSection = document.getElementById(`content-${selectedCurrency}-${selectedPercentage}`);
        if (targetSection) {
            targetSection.style.display = 'flex';
        }

        const staticSection = document.getElementById(`smoking-prevalence-content-${selectedPercentage}`);
        if (staticSection) {
            staticSection.style.display = 'block';
        }

        const dynamicSection = document.getElementById(`dynamic-content-${selectedCurrency}-${selectedPercentage}`);
        if (dynamicSection) {
            dynamicSection.style.display = 'block';
        }
    }
}
